export { default as Navbar } from './Navbar'
export { default as Sidebar } from './Sidebar'
export { default as AppMain } from './AppMain'
export { default as TagsView } from './TagsView'



// WEBPACK FOOTER //
// ./src/views/layout/components/index.js